export default __webpack_public_path__ + "media/d8a1d9e012b052cc9c2a4c74f213217e.png";